import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { appNavigationConfig } from '../../config/app-navigation.config';
import { AuthSessionFacade } from '../../auth/auth-session.facade';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './app-sidebar.html',
  styleUrl: './app-sidebar.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppSidebar {
  private readonly authFacade = inject(AuthSessionFacade);

  protected readonly navigationGroups = computed(() =>
    appNavigationConfig
      .map((group) => ({
        ...group,
        items: group.items.filter(
          (item) => !item.superAdminOnly || this.authFacade.isSuperAdmin()
        ),
      }))
      .filter((group) => group.items.length > 0)
  );
  readonly collapsed = input(false);
  readonly mobileOpen = input(false);
  readonly isMobile = input(false);
}
